






import { Component } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { appStore } from '@/store'
@Component({
  components: {}
})
export default class AtomLabelTori extends ComponentVue {
  get styles(): object {
    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }
}
